// @flow

import type { ContainerDimensions } from '../types';
import type { ResponsiveImageProps } from '../ResponsiveImage';

type Options = {|
  containerDimensionsOverride: $PropertyType<ResponsiveImageProps, 'containerDimensionsOverride'>,
  containerRef: { current: HTMLDivElement | null },
  getImageBasedOnClientInfo: boolean,
  ssrContainerDimensions: $PropertyType<ResponsiveImageProps, 'ssrContainerDimensions'>,
|};

/** Determines and returns the containerDimensions */
const getContainerDimensions = ({
  containerDimensionsOverride,
  containerRef,
  getImageBasedOnClientInfo,
  ssrContainerDimensions,
}: Options): ContainerDimensions | null => {
  // If an override is configured, always use those containerDimensions
  if (containerDimensionsOverride) {
    return containerDimensionsOverride;
  }

  // If not ssrContainerDimensions is defined and getImageBasedOnClientInfo
  // is still false: return null
  if (!ssrContainerDimensions && !getImageBasedOnClientInfo) {
    return null;
  }

  // If we don't yet have useful client containerDimensions
  if (
    containerRef.current === null ||
    containerRef.current.clientHeight === 0 ||
    containerRef.current.clientWidth === 0
  ) {
    // If ssrContainerDimensions is defined, return those containerDimensions
    if (ssrContainerDimensions) {
      return ssrContainerDimensions;
    }

    // Else (we don't have useful containerDimensions yet) return null
    return null;
  }

  // Else (we do have useful client containerDimensions) return client containerDimensions
  const { clientHeight, clientWidth } = containerRef.current;
  return { clientHeight, clientWidth };
};

export default getContainerDimensions;
